import { Apartment } from "../../models/Apartments";
import Style from "./ListApartmentsStyle";

export default function ListApartments({
  enterpriseId,
  blockId,
  apartments,
  props,
}) {
  function NewCreateLayout() {
    const listApartments: Apartment[] = apartments;

    const apartmentsFormatted = listApartments.map((apartment) => {
      const floor = apartment.floor;
      const column = apartment.number;
      return { id: apartment.id, floor, column, number: apartment.number };
    });
    const maxFloor = Math.max(
      ...apartmentsFormatted.map((apartment) => apartment.floor)
    );
    const floors: any[] = [];
    for (let floor = maxFloor; floor >= 0; floor--) {
      const apartmentsButtons: any[] = [];
      apartmentsFormatted.forEach((ap) => {
        if (ap.floor === floor) {
          apartmentsButtons.push(ApartmentButton(ap.id, ap.number));
        }
      });
      floors.push(
        <div className="floor" key={"floor" + floor}>
          {apartmentsButtons}
        </div>
      );
    }
    return floors;
  }

  function ApartmentButton(apartmentId: number, apartmentNumber: number) {
    return (
      <button
        className="exist apartment"
        key={apartmentId}
        onClick={() =>
          props.history.push(`/enterprises/blocks/apartment/${apartmentId}`)
        }
      >
        {apartmentNumber}
      </button>
    );
  }

  return (
    <Style>
      <div className="layout">{NewCreateLayout()}</div>
    </Style>
  );
}
